// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Accessibility: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M13.701 19.048a.853.853 0 0 0 .79.517c.122 0 .243-.03.365-.091a.876.876 0 0 0 .425-1.185s-1.67-3.828-1.974-5.226c-.122-.486-.183-1.792-.213-2.4 0-.212.122-.395.304-.455l3.736-1.124c.456-.122.73-.638.608-1.094-.122-.456-.638-.73-1.094-.608 0 0-3.463 1.124-4.708 1.124-1.216 0-4.649-1.093-4.649-1.093-.455-.122-.972.09-1.124.547-.152.486.122 1.002.608 1.124l3.737 1.124c.182.06.334.243.303.455-.03.608-.09 1.914-.212 2.4-.304 1.398-1.975 5.226-1.975 5.226a.902.902 0 0 0 .425 1.184c.122.061.243.092.365.092.334 0 .668-.183.79-.517L12 15.403l1.701 3.645Z" />
    <path d="M12 7.625a1.701 1.701 0 1 0 0-3.402 1.701 1.701 0 0 0 0 3.402Z" />
    <path d="M24 12c0-6.623-5.377-12-12-12S0 5.377 0 12s5.377 12 12 12 12-5.377 12-12ZM2.005 12c0-5.53 4.496-9.995 9.995-9.995 5.499 0 9.995 4.466 9.995 9.995A9.983 9.983 0 0 1 12 21.995 9.983 9.983 0 0 1 2.005 12Z" />
  </SvgIcon>
);

Accessibility.activeColor = 'inherit';
Accessibility.muiName = 'Accessibility';
